import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import PackagingDamageDispatchCreateView from 'src/sections/packaging-damage-dispatch/view/packaging-damage-dispatch-create-view';

export default function PackagingDamageDispatchCreatePage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> Create a new packaging damage dispatch</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.CREATE_PACKAGING_DAMAGE_DISPATCH,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <PackagingDamageDispatchCreateView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
